<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-lg-12 col-12">
        <div class="row">
          <div class="col-sm-5">
            <input
              type="text"
              class="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Buscar por nombre de curso"
              v-model="valueSearch"
              @keyup.enter="getCourses"
            />
          </div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn bg-gradient-dark null null"
              @click="getCourses()"
              style="margin-left: 10px"
            >Buscar</button>
          </div>
          <div v-show="hasPermission('users.courses.store')" class="col-4 text-end ms-auto">
            <router-link to="/cursos/crear">
              <button type="button" class="btn bg-gradient-success">Crear</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <Table :courses="courses" />
      </div>
    </div>
  </div>
</template>

<script>
import Table from "./components/TableCourse.vue";
import permissionsMixin from "@/mixins/permissionsMixin";
import axios from "axios";

export default {
  name: "CourseList",
  components: {
    Table,
  },
  mixins: [permissionsMixin],
  data() {
    return {
      courses: [],
      valueSearch: null,
    };
  },
  watch: {
    valueSearch(newVal) {
      if (newVal == "") {
        this.valueSearch = null;
        this.getCourses();
      }
    },
  },
  methods: {
    async getCourses() {
      const { status, data } = await axios.get(
        `${process.env.VUE_APP_API_BOOKAPP}courses-all/${this.valueSearch}`,
        {
          headers: {
            Authorization: localStorage.getItem("token_bookapp"),
            conexion: localStorage.getItem("conexion"),
          },
        }
      );
      if (status == 200) {
        this.courses = data;
      }
    },
  },
  mounted() {
    this.getCourses();
  },
};
</script>
